import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Input = ({
  inputRef,
  onValueChange,
  label,
  errorMessage,
  classNames,
  inputContainerClass = "",
  className = "",
  inputClass = "",
  ...props
}) => {
  const [types, setTypes] = useState(props.type || "text");
  const innerClassNames = {
    root: "",
    input: "",
    ...classNames,
  };

  const hideShow = () => {
    types === "password" ? setTypes("text") : setTypes("password");
  };

  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange(e);
    }

    if (onValueChange) {
      onValueChange(e.target.value);
    }
  };

  return (
    <div
      className={`custom-input position-relative ${innerClassNames.root} ${inputContainerClass}`}
    >
      {label ? <label htmlFor={props.id}>{label}</label> : null}

      <div className={`${className} position-relative`}>
        <input
          ref={inputRef}
          className={`form-input ${innerClassNames.input} ${inputClass} ${props.type === "search" ? "pe-4" : ""}`}
          onChange={handleChange}
          {...props}
          type={types}
        />
        {props.type === "search" && !props.value && (
          <div
            className="position-absolute top-50 translate-middle-y"
            style={{ right: 10 }}
          >
            <i className="fa-solid fa-magnifying-glass"></i>
          </div>
        )}

        {props.type === "password" && (
          <div
            className="position-absolute top-50 translate-middle-y cursor"
            style={{ right: 16 }}
            onClick={hideShow}
          >
            {types === "password" ? <Visibility /> : <VisibilityOff />}
          </div>
        )}
      </div>

      {props.type !== "search" && errorMessage && (
        <p className="errorMessage">{errorMessage}</p>
      )}
    </div>
  );
};

export default Input;
